import React from 'react'
import './styles.scss'
import { config } from './config'
import styles from '*.css'

interface Props {
  children: string | JSX.Element
  style?: React.CSSProperties
  className?: string
  big?: boolean
}

export const Hint = ({
  children,
  style,
  className = '',
  big = false
}: Props) => (
  <div className={'ta hint ' + className + (big ? ' big' : '')} style={style}>
    {children}
  </div>
)
